export default "__VITE_ASSET__aV$SFNiY__"